import { useMemo } from 'react';
import * as React from 'react';
import { BusinessCategory, SetupOrgOnboardingSteps } from '@sdk/authentication/types';
import styled from 'styled-components';

import Healthcare1 from '../../assets/images/Healthcare1.png';
import Healthcare2 from '../../assets/images/Healthcare2.png';
import Retail1 from '../../assets/images/Retail1.png';
import Retail2 from '../../assets/images/Retail2.png';
import Transportation1 from '../../assets/images/Transportation1.png';
import Transportation2 from '../../assets/images/Transportation2.png';

const BACKGROUNDS_MAP = {
  [BusinessCategory.healthcare]: {
    [SetupOrgOnboardingSteps.positions]: Healthcare1,
    [SetupOrgOnboardingSteps.employees]: Healthcare2,
  },
  [BusinessCategory.retail]: {
    [SetupOrgOnboardingSteps.positions]: Retail1,
    [SetupOrgOnboardingSteps.employees]: Retail2,
  },
  [BusinessCategory.transportation]: {
    [SetupOrgOnboardingSteps.positions]: Transportation1,
    [SetupOrgOnboardingSteps.employees]: Transportation2,
  },
};

type Props = {
  industry: BusinessCategory;
  step: SetupOrgOnboardingSteps;
};

type BgProps = { img: string };
const BgContainer = styled.div<BgProps>`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  left: 0;
  background-image: url(${({ img }): string => img});
  background-position: right top;
  background-size: auto 100%;
  background-repeat: no-repeat;
`;

const OnboardingBackground: React.FC<React.PropsWithChildren<Props>> = ({
  industry,
  step,
  children,
}) => {
  const img = useMemo(() => BACKGROUNDS_MAP[industry]?.[step] || '', [industry, step]);
  if (!img) {
    return null;
  }

  return <BgContainer img={img}>{children}</BgContainer>;
};

export default OnboardingBackground;
